export function getScores(program, responsibleParty) {
    if (program.length > 0) {
        if (program[0].fitScore == null && program[0].reliabilityScore == null && responsibleParty.riskScore == null && 
            program[0].assistanceCategory != "Medicaid Long Term Care") {
            return {
                overallScore: null,
                riskScore: null,
                reliabilityScore: null,
                fitScore: null,
            };
        }
        let calculatedOverallScore = null;
        if (program.length > 0 && program[0].assistanceCategory == "Medicaid Long Term Care") {
            calculatedOverallScore = program[0].score?.value;
            return {
                overallScore: calculatedOverallScore,
                fitScore: null,
                riskScore: null,
                reliabilityScore: null,
            };
        } else {
            calculatedOverallScore =
                (0.5 * program[0].fitScore * 100 +
                    1.5 * responsibleParty.riskScore +
                    program[0].reliabilityScore * 100) /
                3;
                return {
                    overallScore: calculatedOverallScore,
                    fitScore: program[0].fitScore * 100,
                    riskScore: responsibleParty.riskScore,
                    reliabilityScore: program[0].reliabilityScore * 100,
                };
        }
        
    }
}

export function getScoresWithReasons(programs, responsibleParty, isIncomplete) {
    let scores = {
        overallScore: -1.0,
        fitScore: -1.0,
        riskScore: -1.0,
        reliabilityScore: -1.0,
    };
    let scoreReasons = {
        fitScoreReasons: [],
        reliabilityScoreReasons: [],
        riskScoreReasons: [],
    };

    if (programs.length > 0) {
        let approvedProgram = programs.filter(program => {
            if (program.assistanceCategory != "Cash Discount") {
                return (
                    program.eligibilityDeterminationStatus.name == "Action Complete" ||
                    program.eligibilityStatus.name == "Approved" ||
                    program.eligibilityDeterminationStatus.name == "Pending Supplemental Information"
                );
            } else {
                return !isIncomplete;
            }
        });
        if (approvedProgram.length > 0) {
            scores = getScores(approvedProgram, responsibleParty);
            scoreReasons.fitScoreReasons.push(approvedProgram[0].fitScoreReasons);
            scoreReasons.reliabilityScoreReasons = approvedProgram[0].reliabilityScoreReasons;
            scoreReasons.riskScoreReasons = responsibleParty.riskScoreReasonsWithWeights || [];
        }
    }

    return { scores: scores, scoreReasons: scoreReasons, isIncomplete: isIncomplete };
}
